import { Bell, ChevronDown, Building2 } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
// import brand from "../../../assets/images/brand.webp";
import { useState } from "react";
import { useGetInfo } from "../../../core/api/auth/queris.js";
import { useBuilding } from "../../../core/hooks/useBuilding.js";

function HeaderMainPages() {
    const navigate = useNavigate();
    const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
    const { setBuilding, buildingName: NAME } = useBuilding();
    const buildingName = NAME || "انتخاب ساختمان";
    const { data: info, refetch } = useGetInfo();
    const managers = info?.payload?.managers || [];
    const flats = info?.payload?.flats || [];
    const handleSelectBuilding = (buildingId: number, buildingName: string) => {
        setBuilding(buildingId, buildingName);
        setIsRoleModalOpen(false);
    };
    return (
        <>
            <div className="w-full flex items-center justify-between gap-3">
                <div className="w-1/6 h-10">
                    <img className="w-auto h-full" src={'/app/assets/images/Logo.webp'} alt="logo" />
                </div>

                <div
                    onClick={() => setIsRoleModalOpen(true)}
                    className="w-4/6 flex items-center justify-center gap-1 cursor-pointer text-neutral-700 hover:text-brand-600 transition-colors"
                >
                    {/* <Building2 className="w-4 h-4" /> */}
                    <span className="font-medium truncate max-w-[180px]">{buildingName}</span>
                    <ChevronDown className="w-4 h-4" />
                </div>

                <Link to={"/notifications"} className="flex justify-end w-1/6 cursor-pointer">
                    <Bell className="w-6 h-6 text-brand-600" />
                </Link>
            </div>

         
        </>
    );
}

export default HeaderMainPages;